// Note: This does not apply to the concierge header.

export const getRhrHeaderHeight = (
  isCartPage: boolean,
  size: "default" | "xs"
) => {
  return size === "xs" ? (isCartPage ? 82 : 106) : isCartPage ? 132 : 148;
};
